import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

export default makeStyles(() => ({
  wrapItem: { display: 'flex', alignItems: 'center', cursor: 'pointer' },
  text: { marginLeft: 8 },
  wrapBoxContent: { padding: '12px 20px' },
  titleConnectedUser: { margin: '16px 0 8px 20px', fontSize: 16, color: Colors.Grey10 },
  titleSavedUser: { margin: '16px 0 8px 20px', fontSize: 16 },
  wrapSavedUser: {
    padding: '8px 20px',
    margin: 0,
    '&:hover': { backgroundColor: Colors.Grey5 },
    cursor: 'pointer',
  },
  avatarSaved: { '&.MuiAvatar-root': { width: 32, height: 32, marginRight: 12 } },
  userInfo: { display: 'flex', flexDirection: 'column' },
  textEmailOrPhone: { fontSize: 14, color: Colors.Grey6, marginTop: 4 },
  manualDivider: {
    marginTop: 10,
  },
}));
